var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#00338d;}")),React.createElement("path",{"d":"M17.27,1A16,16,0,1,0,33,17.27,16,16,0,0,0,17.27,1Zm-.52,31A15,15,0,1,1,32,17.25,15,15,0,0,1,16.75,32Z","key":1}),React.createElement("path",{"d":"M26.5,23H7.5a.5.5,0,0,1-.5-.5v-12a.5.5,0,0,1,.5-.5h19a.5.5,0,0,1,.5.5v12A.5.5,0,0,1,26.5,23ZM8,22H26V11H8Z","key":2}),React.createElement("polygon",{"points":"16.97 20 9.99 14.41 9.96 13 16.97 18.64 24.02 12.94 23.99 14.35 16.97 20","key":3})]);
}

Mail.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34"};

module.exports = Mail;

Mail.default = Mail;
